import { render, staticRenderFns } from "./board.vue?vue&type=template&id=a0fd9d4c&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"
import style0 from "./board.vue?vue&type=style&index=0&id=a0fd9d4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fd9d4c",
  null
  
)

export default component.exports